import { render, staticRenderFns } from "./renameFile.vue?vue&type=template&id=018c52fa&scoped=true"
import script from "./renameFile.vue?vue&type=script&lang=js"
export * from "./renameFile.vue?vue&type=script&lang=js"
import style0 from "./renameFile.vue?vue&type=style&index=0&id=018c52fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018c52fa",
  null
  
)

export default component.exports